import { Clock, Scissors } from 'lucide-react';
import { formatCurrency } from '@/lib/utils';
import { ProfessionalSlotPicker } from '../professional-slot-picker';
import type { AppointmentWizard } from './use-appointment-wizard';

/** Passo 3: com quem e a que horas o servico escolhido acontece. */
export function StepProfessional({ wizard }: { wizard: AppointmentWizard }) {
  const service = wizard.current;

  if (!service) {
    return (
      <p className="rounded-lg border border-dashed border-border bg-muted/40 px-4 py-10 text-center text-base text-muted-foreground">
        Escolha um servico antes de marcar o horario.
      </p>
    );
  }

  return (
    <div className="space-y-5">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 rounded-lg border border-border bg-muted/40 px-4 py-3">
        <span className="flex items-center gap-2 text-base font-medium">
          <Scissors className="h-4 w-4 text-muted-foreground" />
          {service.name}
        </span>
        <span className="flex items-center gap-1.5 text-sm text-muted-foreground">
          <Clock className="h-4 w-4" />
          {service.durationMinutes} min
        </span>
        <span className="text-sm text-muted-foreground">{formatCurrency(service.price)}</span>
      </div>

      <ProfessionalSlotPicker
        durationMinutes={service.durationMinutes}
        unitId={wizard.unitId}
        value={wizard.choice}
        onChange={wizard.setChoice}
        suggestedStart={wizard.suggestedStart}
        ignoreAppointmentId={wizard.appointment?.id}
        busy={wizard.busy}
      />
    </div>
  );
}
